import { useEffect, useState, useRef } from 'react';

const buildPath = (node, result = []) => {
  const type = node?.type || {};
  const name = type.displayName || type.name || '';

  if (typeof type === 'string') {
    // real dom element
    result.unshift(`${type}[${node.index}]`);
  } else if (name) {
    result.unshift(`${name}[${node.index}]`);
  }
  if (node.return) {
    return buildPath(node.return, result);
  }

  return result;
};

const useDomPath = () => {
  const ref = useRef(null);
  const [path, setPath] = useState([]);
  useEffect(() => {
    const { current } = ref;
    if (current && current._reactInternalFiber) {
      // @todo should it use .return initially?
      const _path = buildPath(current._reactInternalFiber.return);
      if (_path.join('') !== path.join('')) {
        setPath(_path);
      }
    } else if (current) {
      const _key = Object.keys(current).find((key) => /^__reactInternalInstance\$/.test(key));
      if (_key) {
        const _path = buildPath(current[_key]);
        setPath(_path);
      }
    }
  }, [ref.current]);

  return [path, ref];
};

const getDomPath = (ref) => {
  const { current } = ref;
  let path = [];
  if (current && current._reactInternalFiber) {
    // @todo should it use .return initially?
    path = buildPath(current._reactInternalFiber.return);
  } else if (current) {
    const _key = Object.keys(current).find((key) => /^__reactInternalInstance\$/.test(key));
    if (_key) {
      path = buildPath(current[_key]);
    }
  }
  return path;
};


export {
  useDomPath,
  getDomPath
};
